// Client-side rule-based validation mirroring backend rules.
export const VAGUE_TERMS = [
  "no sirve", "no funciona", "esta mal", "está mal", "malo",
  "bug", "error", "roto", "falla", "prueba", "test", "asdf",
  "aaaa", "xxx", "fix", "arregla", "ayuda", "help", "aaa",
];

export const RULES = {
  title: 10,
  steps: 25,
  expected: 15,
  actual: 15,
};

export const SEVERITIES = [
  { value: "baja", label: "BAJA" },
  { value: "media", label: "MEDIA" },
  { value: "alta", label: "ALTA" },
  { value: "critica", label: "CRÍTICA" },
];

export const BROWSERS = [
  "Chrome", "Firefox", "Safari", "Edge", "Opera", "Brave",
  "Internet", "Línea telefónica", "Impresora", "Otro",
];

export const OS_LIST = [
  "Windows 11", "Windows 10", "macOS 15", "macOS 14", "macOS 13",
  "Ubuntu", "Fedora", "Arch Linux", "iOS", "Android", "Otro",
];

function uniqueWords(text) {
  const words = (text.toLowerCase().match(/[a-záéíóúñü0-9]{3,}/g) || []);
  return new Set(words).size;
}

export function checkVague(text) {
  const t = (text || "").trim().toLowerCase();
  if (!t) return "El campo está vacío. Explícate mejor, joven.";
  for (const term of VAGUE_TERMS) {
    if (t === term || t.startsWith(term + ".") || t.startsWith(term + " ") || t === term + ".") {
      return `'${term}' no es una descripción válida. Explícate mejor, joven.`;
    }
  }
  if (uniqueWords(t) < 3) {
    return "Muy poco contenido único. Explícate mejor, joven.";
  }
  return null;
}

export function validateField(name, value) {
  const min = RULES[name];
  const v = (value || "").trim();
  if (min && v.length < min) {
    return `Mínimo ${min} caracteres. Explícate mejor, joven.`;
  }
  const vague = checkVague(v);
  if (vague) return vague;
  return null;
}
